document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-remove-cart-discount-code');
    if (!btn) return;

    btn.classList.add('loading');

    e.preventDefault();

    fetch('/checkout?discount=CLEAR')
      .then(() => {
        window.location.reload();
      });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector(".js-cart-discount-input");
  const applyBtn = document.querySelector(".js-change-cart-discount-code");

  if (!input || !applyBtn) return;

  input.addEventListener("input", () => {
    if (input.value.trim() !== "") {
      applyBtn.classList.remove("d-none");
    } else {
      applyBtn.classList.add("d-none");
    }
  });

  applyBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    const code = input.value.trim();
    if (!code) return;

    try {
      await fetch(`/checkout?discount=${encodeURIComponent(code)}`, {
        method: "GET",
        mode: "no-cors",
        credentials: "include"
      });
      window.location.reload();
    } catch (err) {
      window.location.reload();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const cartForm = document.querySelector(".js-cart-form");
  const submitBtn = document.querySelector(".js-cart-form button[type='submit']");

  if (!cartForm || !submitBtn) return;

  const checkboxes = cartForm.querySelectorAll("input[type='checkbox']");

  const updateState = () => {
    let hasInvalid = false;

    checkboxes.forEach(cb => {
      if (!cb.checkValidity()) hasInvalid = true;
    });

    cartForm.classList.toggle("has-invalid", hasInvalid);
  };

  checkboxes.forEach(cb => {
    cb.addEventListener("change", updateState);
    cb.addEventListener("input", updateState);
  });

  submitBtn.addEventListener("click", (e) => {
    updateState();
  });
});